/* eslint-disable jsx-a11y/anchor-is-valid */
"use client";
import React, { useState, useEffect } from "react";
import {
  usableNetContainer,
  usableNetLink,
  usableNetIconActive,
  usableNetText,
  usableNetIcon,
  containerTop
} from "./UsableNetButton.css";
import { useSegment } from "tracking";

type Props = {
  usesNewBanner?: boolean;
};

export const UsableNetButton = ({ usesNewBanner = false }: Props) => {
  const [isAccessibilityEnabled, setIsAccessibilityEnabled] = useState(false);
  const { track } = useSegment();

  useEffect(() => {
    const getCookieValue = (name) => {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? match[2] : null;
    };

    const cookieValue = getCookieValue("UsableNetAssistive");
    setIsAccessibilityEnabled(cookieValue === "1");
  }, []);

  const accessibilityToggleText = isAccessibilityEnabled
    ? "Exit Accessibility Mode"
    : "Enable Accessibility";

  const handleClick = (event) => {
    event.preventDefault();

    track({
      event: "Page Element Clicked",
      properties: {
        location_type: "HEADER",
        module_content: "Accessibility Mode Button",
        module_content_details: accessibilityToggleText
      }
    });

    if (isAccessibilityEnabled) {
      if (window.disableUsableNetAssistive) {
        window.disableUsableNetAssistive();
      } else {
        console.warn("window.disableUsableNetAssistive is not defined");
      }
    } else {
      if (window.enableUsableNetAssistive) {
        window.enableUsableNetAssistive();
      } else {
        console.warn("window.enableUsableNetAssistive is not defined");
      }
    }
  };

  const iconClasses = isAccessibilityEnabled
    ? `${usableNetIcon} ${usableNetIconActive}`
    : usableNetIcon;

  // This is to account for the fact that the old banner could show or the new one
  // where the new banner can be two lines tall on small screens
  const bannerTop = usesNewBanner
    ? containerTop.newBanner
    : containerTop.oldBanner;

  return (
    <div
      id="usntA40Toggle"
      className={`${usableNetContainer} ${bannerTop} usntA40bottom-left usntA40Dark`}
    >
      <a
        href="#"
        rel="nofollow"
        id="usntA40Link"
        onClick={handleClick}
        aria-label={accessibilityToggleText}
        className={usableNetLink}
      >
        <div
          id="usntA40Txt"
          role="presentation"
          aria-hidden="true"
          className={usableNetText}
        >
          {accessibilityToggleText}
        </div>
        <i id="usntA40Icon" className={iconClasses}></i>
      </a>
    </div>
  );
};
